module.exports = __webpack_public_path__ + "img/image-plane.c619f6cb.jpg";